import React from "react";
// import defaultImg from "../assets/raven-no-content-img.png";
// import loadingGif from "../assets/raven-loader.gif";
import "./NoContentPage.css";
import { ColorRing } from "react-loader-spinner";



interface MyComponentProps {
  img?: any;
  title?: string;
  text?: string;
  loading?: boolean;
  height?: string;
}

const defaultText =
  "You have not carried out any transactions Yet \n, once you do it would show up here.";

const NoContentPage: React.FC<MyComponentProps> = ({ img, title, text, loading , height}) => {
  return (
    <div style={{height: height ? height : ''}} className="no-content-page-index card-bg">
      {loading ? (
        <>
          <div className="loading-wrap">
            <ColorRing
              visible={true}
              height="70"
              width="70"
              
              ariaLabel="color-ring-loading"
              wrapperStyle={{}}
              wrapperClass="color-ring-wrapper"
              colors={[
                "rgba(115, 71, 146, 1)",
                "rgba(115, 71, 146, 1)",
                "rgba(115, 71, 146, 1)",
                "rgba(115, 71, 146, 1)",
                "rgba(115, 71, 146, 1)",
              ]}
            />
            {/* <figure className="img-box">
              <img src={loadingGif} alt="" className="img" />
            </figure> */}
          </div>
        </>
      ) : (
        <div className="wrap-center-outer-layer grey-bg border-theme">
          <div className="top-box-wrap "></div>
          {/* top end */}
          <div className="bottom-box-wrap table-transaction-cover">
            <div className="wrap-center ">
              {/* <div className="round-img-box table-transaction-cover">
                <div className="round-grey-img grey-bg">
                  <figure className="img-box">{emptyBgImg}</figure>
                </div>
              </div> */}
              {/* <div className="img-center-box fade-purple-bg grey-bg-two">
            <figure className="img-box">
              <img src={img || defaultImg} alt="" className="img" />
            </figure>
          </div> */}
              <div className="title-text-box">
                <p className="title">{title || "Nothing to see here for now..."}</p>
                {text ? (
                  <>
                    {" "}
                    {text.split("\n").map((chi, idx) => {
                      return (
                        <React.Fragment key={idx}>
                          {" "}
                          <p className="text grey-white-color">{chi}</p>
                        </React.Fragment>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {" "}
                    {defaultText.split("\n").map((chi, idx) => {
                      return (
                        <React.Fragment key={idx}>
                          {" "}
                          <p className="text grey-white-color">{chi}</p>
                        </React.Fragment>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoContentPage;
